var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-combobox", {
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          rules: _vm.rules,
          value: _vm.value,
          clearable: "",
          chips: "",
          "small-chips": _vm.dense,
          name: _vm.param.name,
          "deletable-chips": !_vm.readonly,
          items: [],
          multiple: _vm.multiple,
          readonly: _vm.readonly,
          "append-icon": "folder_open"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "click:append": function($event) {
            return _vm.showFileExplorer(_vm.param)
          },
          change: function($event) {
            return _vm.onChange($event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              var index = ref.index
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: {
                      bottom: "",
                      "content-class": "background",
                      "nudge-top": 8
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-chip",
                                _vm._g(
                                  {
                                    staticClass: "path-chip",
                                    attrs: { label: "", close: !_vm.readonly },
                                    on: {
                                      input: function($event) {
                                        return _vm.remove(index)
                                      }
                                    }
                                  },
                                  on
                                ),
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.getPathBasename(item)) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [_vm._v(" "), _c("span", [_vm._v(_vm._s(item))])]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } }),
      _vm._v(" "),
      _vm.file_explorer.visible
        ? _c(
            "FileExplorer",
            {
              attrs: {
                multiselect: _vm.file_explorer.multiple,
                default_folder: _vm.file_explorer.default_value,
                toolbarTitle: _vm.file_explorer.destination_key,
                assetType: _vm.file_explorer.assetType
              },
              on: {
                close: function($event) {
                  _vm.file_explorer.visible = false
                  _vm.file_explorer.destination_key = null
                },
                selectedAssets: _vm.onfileSelected
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Asset Select for Maestro ingester")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7036f876", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7036f876","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/filesystem_path_file_folder.vue
// module id = null
// module chunks = 